import styled from 'styled-components';
export const StyledButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #0078D4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

